/**
 * Generated by orval v7.17.0 🍺
 * Do not edit manually.
 * NEXMAIL (Internal)
 * Internal API consumed by the nexmail dashboard.
 * OpenAPI spec version: 0.0.1
 */

export type StaffQueueControllerQueueV1Sort =
  (typeof StaffQueueControllerQueueV1Sort)[keyof typeof StaffQueueControllerQueueV1Sort];

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const StaffQueueControllerQueueV1Sort = {
  due: 'due',
  send: 'send',
  state: 'state',
  created: 'created',
} as const;
